
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/geo_restriction",
      function () {
        return require("private-next-pages/geo_restriction.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/geo_restriction"])
      });
    }
  